import React from 'react';
import confettiBanner from '../../assets/Confetti@1x.png'
import emoji7 from '../../assets/emoji7.png'
import iconHands from '../../assets/icon_hands.png';

const DownloadPage = ({ changeToContactPage }) => {
    return (
        <div className="download-page-container">
            <div className="download-main-container">
                <div>
                    <div className="download-body-text">
                        <text style={{fontWeight: '700', color: 'black'}}>Thankfully </text> 
                        is not yet publicly available, but you can request accessto join our invitation-only Beta (Apple iOS only).
                    </div>
                </div>
                <img className="emoji" src={iconHands}/>
                <div>
                    <div className="download-body-text-smaller"> Give us your email address to request access to the <text style={{fontWeight: '700', color: 'black'}}>Thankfully</text> invitation-only Beta. We will also notify you as soon as Thankfully is available in the App Store</div>
                </div>
                <div id="mc_embed_signup">
                <form action="https://thankfully.us17.list-manage.com/subscribe/post?u=a685d165cbd46efb6d8550e18&amp;id=c1f1b0767c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" noValidate style={{padding:'0px'}}>
                <div className="email-entry">
                    <input type="email" placeholder="Enter your email address" name="EMAIL" class="email" id="mce-EMAIL" className="request-field"/>
                    <input type="submit" value="Request Invite" name="subscribe" id="mc-embedded-subscribe" class="button" className="request-button"/>
                </div>
                </form>
                </div>
                <div className="footer-div">
                    <div className="android-div">
                        <div className="footer-text">Android User?</div>
                        <a className="footer-link" href="mailto:team@thankfully.com?subject=I want Thankfully for Android">Get in Touch</a>
                    </div>
                    <div className="questions-div">
                        <div className="footer-text">Got questions?</div>     
                        <a onClick={changeToContactPage} className="footer-link">Contact Us</a>                   
                    </div>  
                </div>                
            </div>        
        </div>
    )
}

export default DownloadPage;


// WEBPACK FOOTER //
// ./src/components/HomeDownloadPage/HomeDownloadPage.js